export const SET_UNREAD_COUNT = 'SET_UNREAD_COUNT';

// The below type is a replica of the one used internally by voxeet so
// we can mimic a click of the Chat ActionButton.
export const TOGGLE_ATTENDEES_CHAT = 'TOGGLE_ATTENDEES_CHAT';
